import React from 'react';
import styled from 'styled-components';
import Button from '@material-ui/core/ButtonBase';

import Icon from '../Icon';

const StaticTop = styled.a`
    display: inline-block;
    position: fixed;
    bottom: 5px;
    right: 5px;
    background-color: ${props => props.theme.palette.common.lightWhite};
    z-index: 999;
    padding: 0 1em;
    border-radius: 0.25em;
    border-bottom: none;
    &:active, 
    &:focus,
    &:hover {
      border-bottom: none;
    }
    & button {
      height: 3em;
    }
    @media (min-width: 800px) {
      display: none;
    }
`

const GoToTop = () => (
    <StaticTop href='#top'>
        <Button>
        nach oben
            <Icon
                name='icon-keyboard_arrow_up'
                width='1.25em' height='1.25em'
                iconColor='secondary.main'
            />

        </Button>
    </StaticTop>
);

export default GoToTop;



// WEBPACK FOOTER //
// ./src/components/common/GoToTop.js